import { MeganPage } from "@sunrun/sales-experience-shared";
import { useMeganAdapter } from "adapters/megan";
import { IFrame } from "components/atoms/IFrame";

const MeganIFrame = ({ page }: { page: MeganPage }) => {
  const { basePath, ref, src, title } = useMeganAdapter(page);

  return <IFrame basePath={basePath} ref={ref} title={title} src={src} />;
};

export { MeganIFrame };
